import React from 'react';

const ViewComparisonTabs = ({ activeComparison, onComparisonChange }) => {
  return (
    <div className="comparison-tabs">
      <div className="comparison-label">Compare to:</div>
      <div className="tabs-container">
        <button 
          className={`comparison-tab ${activeComparison === 'local' ? 'active' : ''}`}
          onClick={() => onComparisonChange('local')}
          title="Compare to local area average"
        >
          Local Average
        </button>
        <button 
          className={`comparison-tab ${activeComparison === 'state' ? 'active' : ''}`}
          onClick={() => onComparisonChange('state')}
          title="Compare to state average"
        >
          State Average
        </button>
        <button 
          className={`comparison-tab ${activeComparison === 'national' ? 'active' : ''}`}
          onClick={() => onComparisonChange('national')}
          title="Compare to national average"
        >
          National Average
        </button>
      </div>
    </div>
  );
};

export default ViewComparisonTabs; 